export const importStatus = Object.freeze({
	None: 1,
	FileUploaded: 2,
	InProgress: 3,
	Completed: 4,
	ErrorProcessingFile: 5,
});
